module.exports = __webpack_public_path__ + "3057d0e145b8aec555e83413efd13881.png";